<template>
  <div class="divFullScreenMainEventInfo" v-if="_webStep < 4">
    <v-card v-if="_webStep < 7" class="containerBackground" v-resize="onResize" style="margin-top: 6em;">
      <v-container class="" style="width:auto" grid-list-xl>
        <v-layout row wrap>
          <v-flex v-if="$route.params.type == 't'" xs12 md6>
            <Account-BaseRegistration v-if="_webStep == -1 || _webStep == -2" />
            <Account-Activation v-if="_webStep == -3" />
          </v-flex>
          <v-flex v-else xs12 md12>
            <CustomerSelectionDetails v-if="_webStep == 2" v-on:createTrip="saveMyTrip"></CustomerSelectionDetails>
            <CustomerSelectionWishlist v-if="_webStep == 3" v-on:saveWishlist="saveWishlist"></CustomerSelectionWishlist>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-flex v-else xs8 class="elevation-2 mx-auto containerBackground">
      <v-container style="width:auto; max-height: 80%;" grid-list-xl>
        <v-layout row wrap>
          <v-flex  xs12 md12>
            <NewTripGoToApp></NewTripGoToApp>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-dialog v-model="errorDialog" max-width="320" persistent content-class="dialog_class">
      <v-card>
        <v-card-title class="headline">Error</v-card-title>
        <v-card-text>
          <p class="setFontSize" :style="getFontProperty()">
            {{errorMessage1}}
            <br />
          </p>
          <h3 v-if="errorData">* {{errorData}}</h3>
          <br />
          <p v-if="errorMessage2" class="setFontSize" :style="getFontProperty()">{{errorMessage2}}</p>
          <v-divider></v-divider>
          <p v-if="errorMessage3" class="setSmallFontSize">{{errorMessage3}}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            rounded
            @click="continueAfterErrorDialog"
          >{{$translate('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <v-card v-else class="fullPageScreen" v-resize="onResize">
    <v-img class="backgroundImageFoBookTrip" :src="setBackgroundImageForAccount()">
      <v-layout row>
        <v-flex xs12>
          <TripPlanning></TripPlanning>
        </v-flex>
      </v-layout>
    </v-img>
  </v-card>
</template>

<script>
  import WebStepper from "./WebStepper";
  import * as dssRequest from "../api/dssRequest";
  import appConfig from "../../config/app_config";
  import BaseObject from "../objects/BaseObject";
  import UserTripList from "./UserTripList";
  import Account_BaseRegistration from "./Account/Account_BaseRegistration";
  import Account_Activation from "./Account/Account_Activation";
  import TripOrderOverview from "./TripOrderOverview";
  import TripOrderReady from "./TripOrderReady";
  import LindaOutput from "./LindaOutput";
  import { mapGetters } from "vuex";
  import { objectToArray } from "@/shared/utility.js";
  import _ from "lodash";
  import { ui_helpers } from "../shared/ui_helpers";
  import BaseComponent from "./base/BaseComponent.vue";
  import CustomerSelectionDetails from "./CustomerSelectionDetails";
  import CustomerSelectionWishlist from "./CustomerSelectionWishlist";
  import TripPlanning from "./TripPlanning";
  import NewTripGoToApp from "./NewTripGoToApp";
  import { store } from "../store";

  export default {
    extends: BaseComponent,
    mixins: [ui_helpers],
    name: "MainEventInfo",
    components: {
      WebStepper,
      UserTripList,
      LindaOutput,
      TripOrderOverview,
      TripOrderReady,
      CustomerSelectionDetails,
      CustomerSelectionWishlist,
      TripPlanning,
      NewTripGoToApp,

      "Account-BaseRegistration": Account_BaseRegistration,
      "Account-Activation": Account_Activation
    },
    computed: mapGetters({
      _webStep: "getWebStepId",
      _tripForm: "getTripForm",
    }),
    data() {
      return {
        noEventsFound: false,
        stepId: "",
        warningDialog: false,
        errorDialog: false,
        errorMessage1: "",
        errorMessage2: "",
        errorMessage3: "",
        errorData: "",
        warningMessage: ""
      };
    },
    created() {
      console.log(
        "MainEventInfo",
        this.$route.params.type,
        this.$store.getters["auth/userLevel"],
        this.$route,
        this._webStep
      );
      if (this.$route.params.type == "t" && this._webStep !== -3) {
        this.$store.commit("setWebStepId", -1);
        console.log("MainEventInfo here", this._webStep);
      } else if (
        (this.$store.getters["auth/userLevel"] == 1 || this.$route.params.type == "u") &&
        this._webStep < 0
      )
        this.$store.commit("setWebStepId", 2);
    },
    mounted() {
      window.EventBus.fire("getTagDefUserGroupsAndSystemRoles");
    },

    watch: {
      _webStep: function(newV, oldV) {
        if (newV == 1) {
          console.log("Going back to home because webstep = ", newV)
          this.$router.push({
            name: "Home",
            params: "component"
          });
        }
      }
    },

    methods: {
      setBackgroundImageForAccount() {
        return this.$store.getters.getBackGroundImage;
      },
      onResize() {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        this.carouselHeight = 8.1 * window.innerHeight;
      },
      saveMyTrip() {
        console.log("the tripform complete", this._tripForm);
        const payload = {
          ArrivalDate: this._tripForm.startDate,
          DepartureDate: this._tripForm.endDate,
          ArrivalTime: this._tripForm.ArrivalTime,
          DepartureTime: this._tripForm.DepartureTime,
          TransportMode: this._tripForm.transportName || "Walking",
          GroupSize: Number(this._tripForm.groupSize),
          Name: this._tripForm.name
        };

        dssRequest.doRequest(
          response => {
            console.log(
              "The call for saveMyTrip was successful",
              response
            );
            this._tripForm.tripId = response.data.TripId;

            this.$store.commit("setTripFormTripId", response.data.TripId);

            this.goTo("TripList");
          },
          error => {
            console.log(
              "The call for saveMyTrip was not successful ",
              error
            );
            this.$store.commit("setWebStepId", 7);
          },
          "createTrip",
          this.$store.getters["auth/userName"],
          payload,
        );
      },
      goTo(page, params = "component") {
        // Generic function to let the user move to other component
        this.$router.push({
          name: page,
          params: params
        });
      },
      saveWishlist() {
        let eventObject = {};
        this._tripForm.wishList.forEach((e, i) => {
          let activity = {
            EventId: Number(e.EventId),
            GroupSize: e.groupSize
          };
          eventObject[i + 1] = activity;
        });
        console.log("the tripform complete", this._tripForm);
        const payload = {
          FunctionId: "EventFunctionLibrary::saveWishList",
          TripId: this._tripForm.tripId,
          WishList: eventObject,
        };

        dssRequest.doRequest(
          response => {
            console.log(
              "The call for saveTripDataActivities was successful",
              response
            );

            this.$store.commit("setWebStepId", 4);
          },
          error => {
            console.log(
              "The call for saveTripDataActivities was not successful ",
              error
            );
          },
          "communicateWithDBLibrary",
          appConfig.dss.eventAdminMng,
          payload,
          600000
        );
      },
      getEventDetails(item) {
        console.log("selectEvent", item);
        const payload = {
          EventId: Number(item),
          LanguageTagId: this.$store.getters.getUserLanguage
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getEventDetails was successful",
              response
            );
            let eventInfo = BaseObject._toLowerCaseObjectPropertiesAtFirstLevel(
              response.data
            );
            this.errorData = eventInfo.name;
          },
          error => {
            console.log(
              "The generic call getEventDetails was not successful",
              error
            );
          },
          "getEventDetailsV2",
          appConfig.dss.eventAdminMng,
          payload
        );
      },
      continueAfterErrorDialog() {
        this.errorMessage1 = "";
        this.errorMessage2 = "";
        this.errorMessage3 = "";
        this.errorData = "";
        this.errorDialog = false;
      },
    }
  };
</script>
<style scoped>
  .v-list_tile__sub-title {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .fullPageScreen {
    background-color: none !important;
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -3.4em;
    margin-bottom: -2em;
  }
  .backgroundImageFoBookTrip {
    padding: 1em;
  }
  .divFullScreenMainEventInfo {
    height: 100vh;
  }
</style>

